import store from '@/store'
import { find } from 'lodash'
import { accessDeniedToaster } from '../pop-denied-access'

let guard = () => new Promise((resolve, reject) => {
  return (
    find(store.getters['auth/abilities'], ability =>
      ability.name === 'manage-client-sites' &&
      ability.entity_type === 'Billow\\Models\\Client'
    )
  ) ? resolve() : accessDeniedToaster(reject, {
    name: 'dashboard'
  })
})

export default {
  name: 'manage-client-sites',
  run: guard
}